import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import Button from "../../../common/Button"
import InputBox from "../../../common/interactive/InputBox"
import PannelBody from "../../../fragments/PannelBody"
import { caseQuickUpdate, createLawFirmLocation, editLawFirmLocation, selectLawFirm } from "../../../../lib/fetchApi"
import { buildEntityFormContact } from "../../../../lib/countyResolution"
import { countiesOptions } from "../../../../lib/systemData"
import { useContactCountyConfirmation } from "../../../patient/page/countyMismatchConfirm"
import { notificationActions } from "../../../../store/notifications"
import { caseActions } from "../../../../store/case"
import { attorneyActions } from "../../../../store/attorneys"
import PannelFooter from "../../../fragments/PannelFooter"
import ContactInformation from "./Parts/ContactInformation"

import classes from './Create.module.css'
import { isCompletePhone, isEmail } from "../../../../lib/validation"

const CreateLawFirmLocationForm = ({closeModal, firmData, edit}) => {
    const dispatch = useDispatch()
    const [isLoading, setIsLoading] = useState(false)
    const userToken = useSelector(state => state.user.token)

    const activeCase = useSelector(state => state.case.activeCase)
    const { confirmCountyOnSave, modal: countyMismatchModal } = useContactCountyConfirmation()

    const createLawFirmHandler = async (event) => {
        event.preventDefault()
        setIsLoading(true)

        try {
            const fd = new FormData(event.target)

            const data = Object.fromEntries(fd.entries())

            let errors = []
                    
            if (data && data.email && !isEmail(data.email)) {
                errors.push('Please check Email Field')
            } 

            if (data && data.phone && !isCompletePhone(data.phone)) {
                errors.push('Please check Phone Field')
            }

            if (data && data.cell_phone && !isCompletePhone(data.cell_phone)) {
                errors.push('Please check Cell Phone Field')
            }

            if (data && data.fax && !isCompletePhone(data.fax)) {
                errors.push('Please check Fax Field')
            }

            if (errors && !errors.length) {
                const originalContact = edit ? firmData?.location?.contact_information : null
                const formContact = buildEntityFormContact(data)
                const countyResult = await confirmCountyOnSave({
                    token: userToken,
                    originalContact,
                    formContact,
                    selectedCountyId: data.county,
                    countiesOptions,
                })

                if (countyResult?.error) {
                    dispatch(notificationActions.setError(countyResult.error))
                    return
                }

                if (countyResult.cancelled) {
                    return
                }

                const body = {
                    // name: data.location_name,
                    law_firm_id: firmData.law_firm_id,
                    contact_information: {
                        email: data.email,
                        phone: data.phone,
                        cell_phone: data.cell_phone,
                        phone_2: null,
                        phone_3: null,
                        phone_ext: data.ext,
                        fax: data.fax,
                        address_1: data.address_line_1,
                        address_2: data.address_line_2,
                        city: data.city,
                        state: data.state,
                        county_id: countyResult.countyId,
                        zip: data.zip_code
                    }
                }

                let lawFirmlocation;
                if (edit) { //edit api
                    lawFirmlocation = await editLawFirmLocation(userToken, firmData.location_id, body)
                } else { //create api
                    lawFirmlocation = await createLawFirmLocation(userToken, body)
                }

                if (lawFirmlocation?.errorMessage) {
                    dispatch(notificationActions.setError(lawFirmlocation))     
                } else {            
                    // close modal:
                    closeModal()

                    const body = {
                        folder: 'attorneys',
                        item: {
                            itemId: firmData.id,
                            fields: [
                                {
                                    field: 'location_id',
                                    value: lawFirmlocation?.id
                                },
                                {
                                    field: 'location',
                                    value: lawFirmlocation
                                }
                            ]              
                        },
                    }


                    dispatch(caseActions.modifyActiveCaseMultiple(body))
                    dispatch(attorneyActions.setCreatedlocation(lawFirmlocation))

                    //need to re make the all reps array
                    let repsFromlawFirm =  await selectLawFirm(userToken, firmData.law_firm_id)
                    dispatch(caseActions.setAllRepsOnItem({
                        item_id: firmData.id,
                        folder: 'attorneys',
                        content: repsFromlawFirm
                    }))

                    // if it is not on edit modes, need to bind the created entity to the law firm
                    if (!edit) {
                        let reqBody = {
                            type: 'case_attorney',
                            type_id: firmData.id,
                            fields: {
                                location_id : lawFirmlocation?.id,
                            }
                        }
                        const update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody)
                        if (update?.errorMessage) {
                            dispatch(notificationActions.setError(update))     
                        } else {
                            // DO SOMETHINNG WITH THE FIRM?
                            dispatch(notificationActions.setError({errorMessage: 'Binded to law firm', type:'success'}))
                            
                        }
                    }
                }
            } else {
                dispatch(notificationActions.setError({errorMessage : errors}))
            }
        } finally {
            setIsLoading(false)
        }
    }

    return <form onSubmit={createLawFirmHandler}>
        {countyMismatchModal}
        <PannelBody padding='large' background={'var(--line-transparent)'}>
            <div className={classes.subtitle}>
                Assigned Law Firm
            </div>
            {firmData.law_firm.name}
        </PannelBody>
        {/* <PannelBody padding='large'>
            <InputBox label="Location name" type="text" name="location_name" required={true} placeholder="" currentValue={edit ? firmData.location.name : null}/>
        </PannelBody> */}
        <ContactInformation edit={edit} itemData={firmData} informationType={'location'} requireIdentifier={'attorney_location'} loading={(value) => setIsLoading(value)}/>

        <PannelFooter>
            <Button type='submit' isLoading={isLoading} width={'full'}>
                Submit 
                <i className="ti ti-chevron-right"></i>
            </Button>
        </PannelFooter>
    </form>
}

export default CreateLawFirmLocationForm